import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  resource,
} from '@angular/core';
import { AdminGamesService } from '../../admin-games.service';
import { AdminWheelGame } from '../../admin-games.interface';
import { PlayerRowComponent } from '@core/components/player-row/player-row.component';
import { ModalService } from '@core/modals/services/modal.service';
import { User } from '@core/interfaces/user.interface';
import { CostComponent } from '@core/components/cost/cost.component';
import { LoadingIconComponent } from '@core/components/loading-icon/loading-icon.component';

@Component({
  selector: 'app-admin-wheel-bets-modal',
  imports: [PlayerRowComponent, CostComponent, LoadingIconComponent],
  templateUrl: './admin-wheel-bets-modal.component.html',
  styleUrl: './admin-wheel-bets-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class AdminWheelBetsModalComponent {
  private adminGamesService = inject(AdminGamesService);
  private modalService = inject(ModalService);

  gameid = input.required<AdminWheelGame['gameid']>();

  betsResource = resource({
    params: () => {
      const gameid = this.gameid();

      return {
        gameid,
      };
    },
    loader: async (params) => {
      const response = await this.adminGamesService.loadWheelBet(
        params.params.gameid
      );
      return response;
    },
  });

  public handleOpenAdminUserProfile(
    user: Pick<User, 'steamid' | 'name' | 'avatar'>
  ) {
    // todo: potentially problems, some information unavailable
    this.modalService.openModal('AdminUserModal', {
      user,
      hidePrimaryData: true,
    });
  }
}
